import { FREE_EMAIL_DOMAINS } from "./domains";

export function freeEmailDomainOf(email: string): string | undefined {
  const normalized = email.trim().toLowerCase();
  const domain = normalized.slice(normalized.lastIndexOf("@") + 1);
  return normalized.includes("@") && FREE_EMAIL_DOMAINS.has(domain) ? domain : undefined;
}
